export const PRODUCT_COLUMN_IDS = {
  ItemNo: 'itemNo',
  Image: 'image',
  Brand: 'brand',
  Model: 'model',
  Price: 'price',
  Actions: 'actions',
} as const;
